<template>
  <section class="admin">
    <div class="app">
      <div class="mobile-menu md:hidden">
        <div class="mobile-menu-bar">
          <a href="" class="flex mr-auto">
            <img alt="My Inxait" class="w-6" src="/static/images/logo.svg" />
          </a>
          <a href="javascript:;" @click="menuMobile">
            <app-icon
              :name="'bars'"
              :classname="'w-8 h-8 text-white transform -rotate-90'"
            ></app-icon>
          </a>
        </div>
        <ul class="border-t border-theme-29 py-5 d-block" v-if="!openmenu">
          <app-side-bar :classname="'menu'"></app-side-bar>
        </ul>
      </div>
      <div class="flex">
        <nav class="side-nav">
          <a href="#" class="intro-x flex items-center pl-5 pt-4">
            <img
              alt="Logo"
              class="w-32 xl:block"
              src="/static/images/LOGO-WHITE-2026.png"
            />
          </a>
          <div class="side-nav__devider my-6"></div>
          <app-side-bar :classname="'side-menu'"></app-side-bar>
        </nav>
        <div class="content">
          <app-top></app-top>
          <div class="grid grid-cols-12 gap-6 mt-8">
            <div class="col-span-12 lg:col-span-3 xxl:col-span-2">
              <h2 class="intro-y text-lg font-medium mr-auto mt-2">Trafico</h2>
              <!-- BEGIN: File Manager Menu -->
              <div class="intro-y box p-5 mt-6">
                <div class="mt-1">
                  <router-link
                    to="/admin/traffic/tasks"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/tasks'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'file-plus'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Tareas
                  </router-link>
                  <router-link
                    to="/admin/traffic/emails"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/emails'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'code'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Cortes
                  </router-link>
                  <router-link
                    to="/admin/traffic/campaigns"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/campaigns'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'file'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Campañas
                  </router-link>
                  <router-link
                    to="/admin/traffic/hours"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/hours'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'clock'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Horas Soporte
                  </router-link>
                  <router-link
                    to="/admin/traffic/projects"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/projects'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'file'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Proyectos
                  </router-link>
                  <router-link
                    to="/admin/traffic/accounts"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/accounts'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'folder'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Cuentas
                  </router-link>
                  <router-link
                    to="/admin/traffic/profiles"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/profiles'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'target'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Perfiles
                  </router-link>
                  <router-link
                    to="/admin/traffic/teams"
                    class="flex items-center px-3 py-2 mt-2 rounded-md"
                    :class="{
                      'bg-theme-1 text-white font-medium': subIsActive(
                        '/admin/traffic/teams'
                      ),
                    }"
                  >
                    <app-icon
                      :name="'users'"
                      :classname="'w-4 h-4 mr-2'"
                    ></app-icon>
                    Equipos
                  </router-link>
                </div>
              </div>
              <!-- END: File Manager Menu -->
            </div>
            <div class="col-span-12 lg:col-span-9 xxl:col-span-10">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Icon from '@/components/admin/partials/Icon'
import Top from '@/components/admin/partials/Top'
import SideBar from '@/components/admin/partials/SideBar'

export default {
  name: 'AdminTraffic',
  data() {
    return {
      openmenu: true,
    }
  },
  mounted() {
    if (localStorage.token) {
      this.session()
        .then((user) => {
          this.loading = false
        })
        .catch((message) => {
          this.loading = false
          this.$router.replace(this.$route.query.redirect || '/')
        })
    } else {
      this.loading = false
      this.$router.replace('/')
    }
  },
  methods: {
    ...mapActions(['session']),
    menuMobile() {
      var menu = this.openmenu
      console.log('clic')
      this.openmenu = !menu
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input]
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0
      })
    },
  },
  components: {
    appTop: Top,
    appSideBar: SideBar,
    appIcon: Icon,
  },
}
</script>



// WEBPACK FOOTER //
// AdminTraffic.vue?4d14db1e